import type { UIComponentBase } from '@components/types';

export const ActivityEmptyState = ({ children }: UIComponentBase) => (
  <p className="text-info-400 flex w-full flex-col bg-white p-6 pt-8 text-center text-sm leading-5 font-normal">
    {children}
  </p>
);
